import React from 'react';
import {useState} from "react";
import CheckExportDetails from "./check-expaned-details";

export default function Check(props) {
  const [showModal, setShowModal] = useState(false);

  return (
    <div onClick={() => setShowModal(!showModal)}
         className="shadow-lg rounded-2xl p-4 bg-white dark:bg-gray-800 rounded-2xl hover:bg-sky-100 cursor-pointer	">
      <div className="flex items-center">
        <span className="rounded-xl relative p-4 bg-purple-200">
            <svg width="40" fill="currentColor" height="40"
                 className="text-purple-500 h-4 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                 viewBox="0 0 46 48" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M23.0002 0C12.5068 0 4.00017 8.50659 4.00017 19V32.5335C4.00017 32.8383 3.9145 33.1371 3.75292 33.3956L0.912672 37.94C0.0801118 39.2721 1.0378 41 2.60867 41H43.3917C44.9625 41 45.9202 39.2721 45.0877 37.94L42.2474 33.3956C42.0858 33.1371 42.0002 32.8383 42.0002 32.5335V19C42.0002 8.50659 33.4936 0 23.0002 0ZM23.0002 48C20.2388 48 18.0002 45.7614 18.0002 43H28.0002C28.0002 45.7614 25.7616 48 23.0002 48Z">
                </path>
            </svg>
        </span>
        <p className="text-md text-black dark:text-white ml-2">
          {props.name}
        </p>
      </div>
      <div className="flex flex-col justify-start">
        <p className="text-gray-700 dark:text-gray-100 text-4xl text-left font-bold my-4">
          {props.status}
        </p>
        <div className="flex items-center text-green-500 text-sm">
          <svg className="h-7 w-6 text-green-500" stroke="currentColor" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
          <span>{props.checks.length} Checks passed</span>
        </div>
        <div className="flex items-center text-red-500 text-sm">
          {
            props.errors.length > 0 && (
              <>
                <span className="flex rounded-lg mr-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                     fill="currentColor" className="" viewBox="0 0 1792 1792">
                <path
                  d="M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z">
                </path></svg></span>
                <span>{props.errors.length} Checks failed</span>
              </>
            )
          }
        </div>
      </div>
      {showModal && <CheckExportDetails key={props.name} checks={props.checks} errors={props.errors}/>}
    </div>
  );
}
